<template>
  <div>
      <div v-show="isReady" class="card">
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
            <div class="card-title">
              <router-link :to="{ name: 'store-details-entries', params: { id: $route.params.id } }" class="btn btn-sm btn-light me-4">
                <i class="bi bi-arrow-left me-1"></i>{{ $t('back') }}
              </router-link>
              <div class="d-flex align-items-center flex-equal fw-row me-4 order-2" data-bs-toggle="tooltip"
                data-bs-trigger="hover" title="Date d'établissement">
                <div class="fs-6 fw-bolder text-gray-700 text-nowrap">
                  {{$t('store.output.create.date')}}
                </div>
                <div class="position-relative d-flex align-items-center w-250px">
                  <input class="form-control form-control-transparent fw-bolder pe-5"
                        id="kt_hbd" v-model="formContentOutput.date" required
                        :placeholder="$t('store.entrie.create.date_placeholder')"
                        name="invoice_date" />
                  <span class="svg-icon svg-icon-2 position-absolute ms-4 end-0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                          viewBox="0 0 24 24" fill="none">
                          <path
                              d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                              fill="currentColor" />
                      </svg>
                  </span>
                </div>
              </div>
            </div>
            <div class="card-toolbar">
              <div class="d-flex flex-center flex-equal fw-row text-nowrap order-1 order-xxl-2 me-4"
                  data-bs-toggle="tooltip" data-bs-trigger="hover" title="Enter invoice number">
                  <span class="fs-2 fw-bolder text-gray-800">{{ $t('store.output.titre') }} :
                  </span>
                <input type="text"
                  class="form-control form-control-transparent fw-bolder fs-3 w-250px"
                  :value="numberOut" />
              </div>
              <div class="d-flex align-items-center justify-content-end flex-equal order-3 fw-row"
                  data-bs-toggle="tooltip" data-bs-trigger="hover"
                  title="Specify invoice due date">
                <div class="fs-6 fw-bolder text-gray-700 text-nowrap">{{ $t('store.name') }}
                  : {{ store.name }}</div>
                <div class="position-relative d-flex align-items-center w-150px">
                  <input class="form-control form-control-transparent fw-bolder pe-5" readonly
                      value="" />
                </div>
              </div>
            </div>
        </div>
        <div class="separator separator-dashed"></div>
        <div class="card-body p-12">
          <div class="mb-0">
            <div class="card">
              <div class="card-body rounded bg-light"
                  v-for="(item, key) in formContentOutput.items" :key="key">
                <div class="form-group row">
                  <div class="col-sm-3">
                      <span class="fs-2 text-gray-800">
                          {{ $t('store.output.model') }}
                      </span>
                  </div>
                  <div class="col-sm-8 col-form-label">
                    <div class="form-check form-check-custom form-check-inline mb-2">
                      <input :id="'shop'+id" class="form-check-input me-2 h-20px w-20px form-check-success" @click="checkType('shop')" v-model="item.type" value="shop" required type="radio" />
                      <label class="form-check-label me-5" :for="'shop'+id">
                        <div class="text-gray-800"> {{$t("store.output.shop")}}</div>
                      </label>
                      <input :id="'store'+id" class="form-check-input  me-2 h-20px w-20px form-check-success" @click="checkType('store')" v-model="item.type" value="store" required type="radio" />
                      <label class="form-check-label" :for="'store'+id">
                        <div class="text-gray-800"> {{$t("store.output.store")}}</div>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <select :data-key="key" required
                      class="form-select kt_select2 mb-2 col-sm-10"
                      data-control="select2" v-model="item.entityToable_id" name="shop"
                      data-allow-clear="false">
                    <option></option>
                    <option v-for="entity in entities" :key="entity.id"
                      :value="entity.id">{{ entity.name }}</option>
                  </select>
                </div>
                <hr>
                <div class="row" v-for="(products, id) in item.products" :key="id">
                  <div class="col-sm-4">
                    <select :data-item-key="key" :data-product-key="id"
                            class="mb-6 form-select kt_select2" data-control="select2"
                            v-model="products.product_sale_element_id"
                            name="product_sale_element_output_create"
                            :data-placeholder="$t('store.product_placeholder')"
                            data-allow-clear="false">
                      <option></option>
                      <optgroup v-for="group in groupProducts(filterProductSaleElements(key, id))" :key="group.category_id" :label="group.category_name">
                        <option v-for="product in group.products" :key="product.id" :value="product.id">{{ product.name }}</option>
                      </optgroup>
                    </select>
                  </div>
                  <div class="col-sm-3">
                    <select :data-item-key="key" :data-product-key="id"
                            class="mb-6 form-select kt_select2" data-control="select2"
                            v-model="products.product_lot_id"
                            name="lot"
                            :data-placeholder="$t('store.entrie.create.lot')"
                            data-allow-clear="false">
                      <option v-for="lot in filterProductSaleElementLots(key, id, products.product_sale_element_id)" :key="lot.id" :value="lot.id">
                        {{ lot.lot.name }} ({{ lot.lot.item_number }})
                      </option>
                    </select>
                  </div>

                  <div class="col-sm-3">
                    <input type="number" v-model="products.quantity"
                           min="0" :max="products.maxAvailableQuantity"
                          class="mb-6 form-control" name="date"
                          :placeholder="$t('store.output.create.product_quantity')" />
                  </div>
                  <div class="col-sm-1">
                    <button @click.prevent="dropProductLine(key, id)" type="button"
                            class="btn btn-sm btn-icon text-danger btn-active-color-danger"
                            data-kt-element="remove-item">
                          <span class="svg-icon svg-icon-3">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                    height="24" viewBox="0 0 24 24" fill="none">
                                  <path
                                      d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                      fill="currentColor" />
                                  <path opacity="0.5"
                                        d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                        fill="currentColor" />
                                  <path opacity="0.5"
                                        d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                        fill="currentColor" />
                              </svg>
                          </span>
                    </button>
                  </div>
                  <hr>
                </div>
                <div class="row">
                  <div class="col-sm-8"></div>
                  <div class="col-sm-4">
                    <button @click.prevent="addLigneProduct(key)" type="button"
                            class="btn btn-sm btn-light-primary">
                      <i class="fa fa-plus"></i>
                      {{ $t('product.add_product') }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="mt-5 d-flex justify-content-end">
                <button @click="createOutput(true)" class="btn btn-sm btn-light-danger me-2" id="kt_invoice_submit_button"
                        :disabled="isLoading1">
                  <span class="indicator-label" v-if="!isLoading1">{{ $t('button.draft') }}</span>
                  <span class="" v-else>{{ $t('loading') }}
                      <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                </button>
                <button @click="sendOutput" class="btn btn-sm btn-primary" id="kt_invoice_submit_button"
                    :disabled="isLoading2">
                  <span class="indicator-label" v-if="!isLoading2">{{ $t('button.send') }}</span>
                  <span class="" v-else>{{ $t('loading') }}
                      <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                  </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="!isReady" class="row loader text-center">
        <Loader />
      </div>
  </div>
</template>


<script>
import AppSubHeader from "@/views/Settings/Stores/partials/AppSubHeaderStoreOutputCreate.vue";
import { mapActions, mapGetters } from 'vuex'
import { groupProductsByCategory } from '@/composables/productCategoryGroups'
import Loader from "@/components/Loader.vue";
export default {
  components: {
    AppSubHeader,
    Loader,
  },
  data() {
    let date = new Date().getDate();
    let month = new Date().getMonth() + 1;
    let year = new Date().getFullYear();
    let formattedDate = `${(date < 10) ? '0' + date : date}/${(month < 10) ? '0' + month : month}/${year}`;
    return {
      isLoading1: false,
      isLoading2: false,
      productSaleElement: [],
      supplier: {},
      store: {},
      numberOut: '',
      entrieDetails: {},
      quantity: 0,
      title: i18n.global.t('store.transfer'),
      breadcrumbs: [
        {
          name: i18n.global.t('breadcrumbs.setting.setting'),
          path: '/admin/settings-index/items'
        },
        {
          name: i18n.global.t('breadcrumbs.store.path'),
          path: '/admin/stores'
        },
        {
          name: i18n.global.t('breadcrumbs.store.output.pathOutput'),
          path: '/admin/settings-index/store/' + this.$route.params.id + '/create/output'
        }
      ],
      formContentOutput: {
        entityFromable_id: this.$route.params.id,
        numero: '',
        type: 'store',
        date: formattedDate,
        status: 'Draft',
        items: [
          {
            entityToable_id: null,
            type: 'shop',
            products: [
              {
                product_sale_element_id: null,
                quantity: null,
                comments: '',
                maxAvailableQuantity: 0,
                product_lot_id : null
              }
            ],
          }
        ]
      },
      entities: {},
      productLot: [],
      porductSaleElementLots: [],
      placeholder: '',
      isReady: false
    }
  },

  watch: {
    formContentOutputItemsLength: function () {
      this.$nextTick(() => {
        this.initSelect2({
          dateFormat: "d/m/Y",
        })
      })
    },
  },

  async mounted() {
    this.$store.dispatch('categories/loadCategories')
    this.isReady = false

    this.getProductSale()
    await this.loadShops({ status: "active", search: "" })
    this.loadStore({status: "all", search: null})
    this.loadLots()
    this.initProductSaleElementLots()
    this.entities = this.getShops.filter((shop) => {
      let stores = shop.stores.filter((store) => {
        return store.id === this.$route.params.id
      })
      return shop.archive == false && stores.length
    })
    this.placeholder = i18n.global.t('store.shop_placeholder')

    let response = await this.showStore(this.$route.params.id)
    this.store = response.data.store
    let prefix = this.store.transfer_number ?  this.$addYearToPrefixe(this.store.transfer_number)  : 'TRA/' + this.store.name.slice(0, 3).toUpperCase() + '/' + (new Date()).getFullYear()
    this.numberOut = prefix + '/' + this.$incrementValue(response.data.ouputNumber)

    $("#kt_hbd").flatpickr({
      dateFormat: "d/m/Y",
    });

    this.initSelect2()

    this.isReady = true
  },
  computed: {
    ...mapGetters('shop', ['getShops']),
    ...mapGetters('categories', ['getCategories']),
    ...mapGetters('store', ['getStores']),
    ...mapGetters('lots',['getLots']),

    formContentOutputItemsLength() {
      return JSON.stringify(this.formContentOutput.items)
    }
  },

  methods: {
    ...mapActions('products', ['loadProductSaleStore','getProductSaleElementLot','listProductLots']),

    groupProducts(products) {
      return groupProductsByCategory(products, this.getCategories)
    },
    ...mapActions('store', ['loadStore', 'createOutputStore', 'showStore', 'getDetailsProd', 'numberEntryOutput']),
    ...mapActions('shop', ['loadShops']),
    ...mapActions('lots',['loadLots']),


    filterProductSaleElements(key, id) {
      let productBeforeKey = [];

      for (let i = 0; i < id; i++) {
        const productSale = this.formContentOutput.items[key].products[i];
        if (this.filterProductSaleElementLots(key, i, productSale.product_sale_element_id).length === 0) {
          productBeforeKey.push(productSale.product_sale_element_id);
        }
      }

      let product_lists = this.productSaleElement.filter(product => !productBeforeKey.includes(product.id));
      return this.sortByKey(product_lists, "name");
    },
    filterProductSaleElementLots(key, id, product_sale_element_id) {
      if(product_sale_element_id != null){
        let newProductLots = this.porductSaleElementLots.filter(lot => lot.product_sale_element_id === product_sale_element_id);
        let productBeforeKey = this.formContentOutput.items[key].products
            .filter((data, i) => i < id)
            .map(data => data.product_lot_id);

        return newProductLots.filter(lot => !productBeforeKey.includes(lot.id));
      }
      return []
    },
    sortByKey(array, key) {
      return array.sort(function(a, b) {
        var x = a[key].toLowerCase();
        var y = b[key].toLowerCase();
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      });
    },
    async initProductSaleElementLots(){
      let response = await this.listProductLots()
      this.porductSaleElementLots = response.data
    },


    async loadDetailsProd(data) {
      let response = await this.getDetailsProd(data)
      this.entrieDetails = response.data.details
    },

    async getProductSale() {
      await this.loadProductSaleStore(this.$route.params.id).then((response) => {
        this.productSaleElement = response.data.product_sale_element
      }).catch((err) => {
        window.toastr['error'](err)
      });
    },

    getQuantityById(productId) {
      for (const product of this.productSaleElement) {
        if (product.id === productId) {
          return product.quantity;
        }
      }
      return 0;
    },

    getFilteredProducts(key, k) {
      console.log(this.productSaleElement)
        let productBeforeKey = this.formContentOutput.items[key].products
          .filter((data, i) => i < k)
          .map(data => data.product_sale_element_id)
        return Object.values(this.productSaleElement).filter(product => !productBeforeKey.includes(product.id))
    },

    checkType(value){
      if(value == 'store'){
        this.entities = this.getStores.filter((store) => {
          return (store.id !== this.$route.params.id && store.etat == 'active')
        })
        this.placeholder = i18n.global.t('store.store_placeholder')
      }

      if(value == 'shop'){
        this.entities = this.getShops.filter((shop) => {
          let stores = shop.stores.filter((store) => {
            return store.id === this.$route.params.id
          })
          return shop.archive == false && stores.length
        })
        this.placeholder = i18n.global.t('store.shop_placeholder')
      }
    },

    addLigne() {
      this.formContentOutput.items.push(
          {
            entityToable_id: null,
            type: '',
            products: [
              {
                product_sale_element_id: null,
                quantity: null,
                comments: '',
                maxAvailableQuantity: 0,
                product_lot_id : null
              }
            ],
          }
      )

      this.initSelect2()
    },
    addLigneProduct(key) {
      this.formContentOutput.items[key].products.push(
          {
            product_sale_element_id: null,
            type: '',
            quantity: null,
            comments: '',
            maxAvailableQuantity: 0,
            product_lot_id : null
          }
      )
      this.initSelect2()
    },

    formatProduct(items) {
      return (items.attribut?.length > 0) ? ' (' + items.attribut + ')' : '';
    },

    async createOutput(bool) {
      let response = {}
      bool ? this.isLoading1 = true : this.isLoading2 = true
      try {
        bool ? this.isLoading1 = false : this.isLoading2 = false
        this.formContentOutput.numero = this.numberOut
        response = await this.createOutputStore(this.formContentOutput)
        window.toastr['success'](i18n.global.t('notification.store.output_create'))
        this.$router.push({ name: 'store-details-entries', params: { id: this.$route.params.id } })
      } catch (e) {
        bool ? this.isLoading1 = false : this.isLoading2 = false
        if (response && response.data) {
          window.toastr['error'](response.data.error)
        }
      }
    },

    async sendOutput() {
      this.formContentOutput.status = "Send"
      await this.createOutput(false)
    },

    dropShopLigne(key) {
      if (this.formContentOutput.items.length > 1) {
        this.formContentOutput.items.splice(key, 1)
      }
    },

    dropProductLine(key, id) {
      if (this.formContentOutput.items[key].products.length > 1) {
        this.formContentOutput.items[key].products.splice(id, 1)
      }
    },

    initSelect2() {
      $(".kt_select2").select2()
      $(".kt_select2").select2().select2()

      $(".kt_select2").change((e) => {
        switch (e.target.name) {
          case 'shop':
            this.formContentOutput.items[e.target.getAttribute('data-key')].entityToable_id = e.target.value
            break;
          case 'product_sale_element_output_create':
            let data = {
              entityFromable_id: this.$route.params.id,
              productSaleElement_id: e.target.value
            }
            // this.loadDetailsProd(data)
            this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].product_sale_element_id = e.target.value
            this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].maxAvailableQuantity = this.getQuantityById(e.target.value)
            this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].quantity = this.getQuantityById(e.target.value)
            this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].product_lot_id = null
            break;
          case 'lot':
            this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].product_lot_id = e.target.value
            this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].quantity = null
            break;
          default:
            break;
        }
      });

      $(".kt_select2").select2({
        placeholder: this.placeholder
      });
    }
  }
}
</script>

<style scoped>
</style>